// Copyright (C) 2012 Minted Inc.
// All Rights Reserved

M.View = M.View || {};
M.View.Sample = M.View.Sample || {};

/**
 * @class M.View.Sample.ConfirmDialog
 *
 */
M.View.Sample.ConfirmDialog = Backbone.View.extend({
  className: 'sampleConfirmDialog',

  events: {
    'click .keepShopping': 'closeDialog'
  },

  template: _.template(M.Template.Sample.ConfirmDialog),

  initialize: function() {
    this.$el = $(this.el);
  },

  render: function() {
    var that = this;

    this.$el.html(this.template(this.options));

    this.$el.dialog({
      modal: true,
      draggable: false,
      resizable: false,
      width: 472,
      position: ['center', 50],
      title: 'Your sample is in your cart.',
      open: function() {
        // Remove any quick look dialogs that may still be open
        $('.quickLookDialog').remove();
      }
    });

    return this.$el;
  },

  closeDialog: function() {
    this.trigger('close');
    this.$el.dialog('close');
  }

});
